import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import LandingSection from '../../MyComponents/LandingSections/LandingSection';
import SectionEyebrow from '../../MyComponents/LandingSections/SectionEyebrow';
import userApi from '../../Api/userApi';
import { MANAGE_CLASSES_LINK } from '../../common/urlLinks';
import { CARD, PILL_PRIMARY } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

const useStyles = makeStyles(() => ({
    card: {
        ...CARD,
        maxWidth: '640px',
        margin: '0 auto',
        padding: 'clamp(28px, 4vw, 48px)',
        textAlign: 'center',
    },
    eyebrowRow: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '22px',
    },
    badge: {
        display: 'grid',
        placeItems: 'center',
        width: '84px',
        height: '84px',
        margin: '0 auto 22px',
        borderRadius: '50%',
        background: REDESIGN_COLORS.mist,
        color: REDESIGN_COLORS.primary,
    },
    title: {
        margin: '0 0 12px',
        fontSize: 'clamp(1.5rem, 3vw, 2.1rem)',
        lineHeight: 1.15,
        letterSpacing: '-0.03em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
        textWrap: 'balance',
    },
    text: {
        margin: 0,
        color: REDESIGN_COLORS.body,
        fontSize: '1rem',
        lineHeight: 1.6,
    },
    cta: {
        ...PILL_PRIMARY,
        minHeight: '48px',
        marginTop: '26px',
    },
}));

/**
 * Opened on the phone from the QR code the board shows: claims the one-time
 * link for the signed-in account, then tells the visitor the board is in.
 */
const ApproveLinkWhiteboard = ({ match }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (match.params.id) {
            userApi.linkWhiteboard(match.params.id).then(() => setLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid item xs={12}>
            <LandingSection id="top" background="none" gutter={0} paddingTop={24} paddingBottom={56}>
                <div className={classes.card} role="status" aria-live="polite">
                    <div className={classes.eyebrowRow}>
                        <SectionEyebrow>
                            <FormattedMessage id="redesign.linkWhiteboard.eyebrow" />
                        </SectionEyebrow>
                    </div>
                    <div className={classes.badge}>
                        {loading ? (
                            <CircularProgress size={36} color="inherit" />
                        ) : (
                            <svg
                                width="40"
                                height="40"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                            >
                                <polyline points="4 12.5 9.5 18 20 7" />
                            </svg>
                        )}
                    </div>
                    <h1 className={classes.title}>
                        <FormattedMessage
                            id={loading ? 'page.linkwhiteboard.allowlink.loading' : 'page.linkwhiteboard.allowlink.done1'}
                        />
                    </h1>
                    {loading ? null : (
                        <>
                            <p className={classes.text}>
                                <FormattedMessage id="page.linkwhiteboard.allowlink.done2" />
                            </p>
                            <Link to={MANAGE_CLASSES_LINK} className={classes.cta}>
                                <FormattedMessage id="redesign.linkWhiteboard.approve.cta" />
                                <span aria-hidden="true">→</span>
                            </Link>
                        </>
                    )}
                </div>
            </LandingSection>
        </Grid>
    );
};

export default ApproveLinkWhiteboard;
